import our_mission from "../../Assets/our_mission.jpg";
import our_vision from "../../Assets/our_vision.jpg";
import our_promise1 from "../../Assets/our_promise1.jpg";
import our_promise2 from "../../Assets/our_promise2.jpg";
import our_promise3 from "../../Assets/our_promise3.jpg";
import about from "../../Assets/about.jpg";
import aboutlast from "../../Assets/about-last.jpg";

export const serviceShowcaseData = [
  {
    imgSrc: about,
    title: `Transforming Healthcare, \n One Home at a Time`,
    paragraph: `Wihan brings trusted CarePreneurs and leading hospitals \n together to deliver care at your doorstep.`,
    buttonText1: "Book Home Care Now",
    buttonText2: "Join as CarePreneur",
    buttonLink1: "https://wihan.in/",
    buttonLink2: "https://provider.wihan.in/",
  },
];

export const title = `Transforming Healthcare, One Home at a Time`;
export const paragraph = `Wihan brings trusted CarePreneurs and leading hospitals together to deliver care at your doorstep.`;

export const our_mission_data = {
  img: our_mission,
  title: `Our Mission`,
  para1: `At Wihan, we are on a mission to transform the way healthcare is delivered at home.\n We believe that quality care should not be confined to hospital walls—it should\n extend to where people feel safest and most comfortable: <strong class="strong-color"> their homes. </strong>`,
  para2: `Wihan is building <strong class="strong-color"> India’s largest CarePreneurs and Referral Hospital Network, </strong > empowering\n trained healthcare professionals and partnering with leading hospitals to provide reliable,\n accessible, and compassionate home healthcare services.`,

  para3: `From <strong class="strong-color"> nursing and physiotherapy to elder care, palliative support, and post-hospitalization \n recovery, </strong> we bring medical excellence and personalized care directly to patients’ doorsteps.`,
};

export const our_vision_data = {
  title: `Our Vision`,
  para: `To redefine healthcare delivery by creating \n a strong ecosystem of hospitals and care \n professionals that ensures every patient \n receives timely, affordable, and trusted \n care at home.`,
  img: our_vision,
};

export const our_promise_data = [
  {
    title: `Trusted CarePreneurs`,
    para: `Skilled and trained healthcare professionals
dedicated to quality care.`,
    img: our_promise1,
  },
  {
    title: `Hospital Partnerships`,
    para: `Seamless collaboration with referral hospitals for
comprehensive support.`,
    img: our_promise2,
  },
  {
    title: `Compassion First`,
    para: `Beyond treatment, we focus on dignity, comfort,
and emotional wellbeing.`,
    img: our_promise3,
  },
];

export const aboutus_last = {
  img: aboutlast,
  para: `“ At Wihan.in, we are not just delivering healthcare
we are building healthier communities, empowering
professionals, and shaping the future of home-based
care in India. “`,
  btn_text: `Get Started Today`,
};
